import { takeEvery } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';

import { apiSagaV2 } from 'src/helpers/saga';
import { CommandsApi } from 'src/api';

import * as commandsActions from './actions';

const getCommands = apiSagaV2(commandsActions.getCommands, async (connection, action) => {
  const { siteId } = action.payload;
  return new CommandsApi(connection).getCommands(siteId);
});

const runCommand = apiSagaV2(commandsActions.runCommand, async (connection, action) => {
  const { siteId, command } = action.payload;
  return new CommandsApi(connection).runCommand(siteId, command);
});

export function* commandsSagas() {
  yield takeEvery(getType(commandsActions.getCommands.request), getCommands);
  yield takeEvery(getType(commandsActions.runCommand.request), runCommand);
}
